import { isApiEntity, isComponentEntity } from '@backstage/catalog-model';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import { isSolutionModuleEntity } from '@ipen-portal/ipen-entity-model';
import { and, not, or, showMonitoring } from '@ipen-portal/plugin-common';
import { TrpcApiBlueprint } from '@ipen-portal/plugin-trpc-react';

import { changelogApiRef } from './apis';
import { rootRouteRef } from './routes';
import { hasChangelogAnnotation } from './utils/hasChangelogAnnotation';

export const changelogPlugin = createFrontendPlugin({
  extensions: [
    EntityContentBlueprint.make({
      name: 'ChangelogPage',
      params: {
        filter: and(
          hasChangelogAnnotation,
          showMonitoring,
          or(isApiEntity, isComponentEntity),
          not(isSolutionModuleEntity),
        ),
        icon: <Icon icon="material-symbols:subject" />,
        loader: () =>
          import('./components/EntityChangelogContent').then(m => (
            <m.EntityChangelogContent />
          )),
        path: '/changelog',
        routeRef: rootRouteRef,
        title: 'Changelog',
      },
    }),
    TrpcApiBlueprint.make({
      name: 'changelog-api',
      params: defineParams =>
        defineParams({
          apiRef: changelogApiRef,
          path: 'changelog',
        }),
    }),
  ],
  pluginId: 'changelog',
  routes: {
    root: rootRouteRef,
  },
});
